import { render, staticRenderFns } from "./MskuRuleDialog.vue?vue&type=template&id=c8f816e4&scoped=true"
import script from "./MskuRuleDialog.vue?vue&type=script&lang=js"
export * from "./MskuRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./MskuRuleDialog.vue?vue&type=style&index=0&id=c8f816e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f816e4",
  null
  
)

export default component.exports